import { inject } from '@angular/core';

import { AuthService } from './services/auth.service';
import { TenantService } from './services/tenant.service';

/**
 * Runs once before bootstrap: tenant resolution, then session restore.
 * Registered via `provideAppInitializer` in `app.config.ts`.
 */
export function initializeApp(): Promise<void> {
  const tenantService = inject(TenantService);
  const authService = inject(AuthService);

  tenantService.initializeOnce();
  return authService.bootstrapSession();
}
